import { Tabs } from 'antd';
import React, { FC, useState } from 'react';
import { useTranslation } from 'hooks/use-translation';
import { StatusupdateTemplateConfiguration } from './status-update-configuration';
import { ConfigurationTab, Pane } from './styles';
import { StatusUpdateTemplateHighlights } from './su-template-highlights';

const { TabPane } = Tabs;

enum TabNames {
  Configuration = 'configuration',
  Highlights = 'highlights',
}

const Configuration = () => {
  const ConfigurationLabel = useTranslation(
    'templates.status_updates.tab.config',
  );

  return <ConfigurationTab>{ConfigurationLabel}</ConfigurationTab>;
};

export const StatusUpdateTemplateTabs: FC = () => {
  const [activeTab, setActiveTab] = useState<TabNames>(TabNames.Highlights);

  const HighlightsLabel = useTranslation(TabNames.Highlights);

  return (
    <Pane>
      <Tabs
        activeKey={activeTab}
        onChange={(tab) => {
          setActiveTab(tab as TabNames);
        }}
      >
        <TabPane tab={HighlightsLabel} key={TabNames.Highlights}>
          <StatusUpdateTemplateHighlights />
        </TabPane>
        <TabPane tab={<Configuration />} key={TabNames.Configuration}>
          <StatusupdateTemplateConfiguration />
        </TabPane>
      </Tabs>
    </Pane>
  );
};
